<div>
    <p>
        {{ message() }}
    </p>
    <p>Are you sure you want to continue?</p>

    <div class="mt-4">
        <p-button (click)="close()" styleClass="mr-4" [text]="true" severity="success">
            <div class="font-[600]">
                {{ cancelLabel() }}
            </div>
        </p-button>
        <p-button (click)="discard()" [text]="true" styleClass="!font-[600]" severity="danger">
            <div class="font-[600]">
                {{ actionLabel() }}
            </div>
        </p-button>
    </div>
</div>
